import {
  INSERT_NEW_ROW,
  UPDATE_TABLE_ROWS,
  EDIT_ROW_TABLE_ATIVIDADES,
  UPDATE_TABLE_ATIVIDADES_EDITED_ROW,
  UPDATE_TOTAL_CRONOGRAMA,
  SET_TIPO_ALVARA,
  RESET_ATIVIDADES_STATE
} from '../actions/actionTypes';

import {
  resolverUnidadeCronograma,
  transformarMesesEmDias
} from 'common/Utils';

const initialState = {
  tabelaAtividades: [],
  dadosEdicao: {
    editarRow: false,
    rowIndex: -1,
    rowData: null
  },
  totalCronogramaOriginal: 0,
  totalCronograma: 0,
  totalOrcamento: 0,
  tipoAlvara: 1
};

function somatorioOrcamento(atividades) {
  return atividades.reduce(
    (a, d) => a + parseFloat(d.orcamento.replace(',', '.')),
    0
  );
}

function somatorioCronograma(atividades) {
  const atividadesParalelas = atividades.filter((x) => x.paralela);
  const atividadesNaoParalelas =
    atividadesParalelas.length > 1
      ? atividades.filter((x) => !x.paralela)
      : atividades;

  let totalDias = 0;
  if (atividadesNaoParalelas.length > 0) {
    totalDias = calcularTotalCronograma(atividadesNaoParalelas);
  }

  if (atividadesParalelas.length > 1) {
    const atividadesParelelasPrazo = atividadesParalelas.map((x) =>
      resolverUnidadeCronograma(x.cronograma.unidade, x.cronograma.prazo)
    );
    const maiorPrazoParalelo = Math.max(...atividadesParelelasPrazo);

    return totalDias + maiorPrazoParalelo;
  }

  return totalDias;
}

function somatorioCronogramaOriginal(atividades) {
  return calcularTotalCronograma(atividades);
}

function calcularTotalCronograma(atividades) {
  const atividadeComMeses = atividades.filter(
    (x) => x.cronograma.unidade === 2
  );
  const atividadesSemMeses = atividades.filter(
    (x) => x.cronograma.unidade !== 2
  );

  const totalMeses =
    atividadeComMeses.length > 0
      ? atividadeComMeses.reduce((a, m) => a + parseInt(m.cronograma.prazo), 0)
      : 0;
  const mesesEmDias = transformarMesesEmDias(totalMeses);

  const dias =
    atividadesSemMeses.length > 0
      ? atividadesSemMeses.reduce(
          (a, d) =>
            a +
            resolverUnidadeCronograma(d.cronograma.unidade, d.cronograma.prazo),
          0
        )
      : 0;

  const totalDias = mesesEmDias + dias;
  return totalDias;
}

export const tabelaAtividadeReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSERT_NEW_ROW:
      const atividades = [...state.tabelaAtividades, action.newValue];
      return {
        ...state,
        tabelaAtividades: atividades,
        totalCronogramaOriginal: somatorioCronogramaOriginal(atividades),
        totalCronograma: somatorioCronograma(atividades),
        totalOrcamento: somatorioOrcamento(atividades)
      };

    case UPDATE_TABLE_ROWS:
      let newDadosEdicao = { ...state.dadosEdicao };

      if (newDadosEdicao.editarRow) {
        const atividadeEdicao = action.newValue.filter(
          (x) => x.id === newDadosEdicao.rowData.id
        )[0];

        if (atividadeEdicao) {
          const newIndex = action.newValue.findIndex(
            (x) => x.id === newDadosEdicao.rowData.id
          );
          newDadosEdicao.rowIndex = newIndex;
        } else {
          newDadosEdicao.editarRow = false;
          newDadosEdicao.rowIndex = -1;
          newDadosEdicao.rowData = null;
        }
      }

      return {
        ...state,
        tabelaAtividades: action.newValue,
        dadosEdicao: newDadosEdicao,
        totalCronogramaOriginal: somatorioCronogramaOriginal(action.newValue),
        totalCronograma: somatorioCronograma(action.newValue),
        totalOrcamento: somatorioOrcamento(action.newValue)
      };

    case EDIT_ROW_TABLE_ATIVIDADES:
      return {
        ...state,
        dadosEdicao: action.newValue
      };

    case UPDATE_TABLE_ATIVIDADES_EDITED_ROW:
      const newData = [...state.tabelaAtividades];
      const index = state.dadosEdicao.rowIndex;
      newData[index] = action.newValue;

      return {
        ...state,
        tabelaAtividades: newData,
        dadosEdicao: {
          editarRow: false,
          rowIndex: -1,
          rowData: null
        },
        totalCronogramaOriginal: somatorioCronogramaOriginal(newData),
        totalCronograma: somatorioCronograma(newData),
        totalOrcamento: somatorioOrcamento(newData)
      };

    case UPDATE_TOTAL_CRONOGRAMA:
      return {
        ...state,
        totalCronograma: parseInt(action.newValue)
      };

    case SET_TIPO_ALVARA:
      return {
        ...state,
        tipoAlvara: action.newValue
      };

    case RESET_ATIVIDADES_STATE: {
      return {
        ...initialState
      }
    }

    default:
      return state;
  }
};
